import useAuth from "../../routes/login/AuthContext";
import { RenameRoom, UpdateNumberInL3 } from "../../services/NetworkApi";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";

export const useUpdateRoom = (l2Id: number, l3Id: number, l4Id: number) => {
  const { getAuthToken } = useAuth();
  const { updateRoomValues } = useNetworkContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const handleRename = async (roomName: string) => {
    await RenameRoom(
      selectedNetworkId,
      l2Id,
      l3Id,
      l4Id,
      { roomName },
      await getAuthToken()
    );
    return updateRoomValues(selectedNetworkId, l2Id, l3Id, l4Id, {
      name: roomName,
    });
  };

  const handleNumberInL3Update = async (numberInL3: number) => {
    await UpdateNumberInL3(
      selectedNetworkId,
      l2Id,
      l3Id,
      l4Id,
      { numberInL3 },
      await getAuthToken()
    );
    return updateRoomValues(selectedNetworkId, l2Id, l3Id, l4Id, {
      numberInL3: numberInL3,
    });
  };

  return { handleRename, handleNumberInL3Update };
};
